import {AssetLoader} from './AssetLoader';
import {FSM_CLOCK} from './fsm/FSM_CLOCK';
import {UI} from './UI';
import gsap from 'gsap';
import {FSM} from './fsm/FSM';
import {IRWNCamera} from './IRWNCamera';
import {MaterialManager} from './MaterialManager';
import {IRWN} from './IRWN';
import {AudioManager} from './AudioManager';
import {CreatureManager} from './CreatureManager';
import {ClockScene} from './ClockScene';
import {Blob} from './Blob';
import AxL from '../axl';

const LandingPageScene = {

  children: [],
  Params: {
    // Background
    bgPos: {x: 0, y: 0, z: -12},
    bgScl: 0.02,

    // flowers left / right
    flowerLeftPos: {x: -5, y: -2, z: -5},
    flowerLeftPos_portrait: {x: -0.5, y: -4, z: -5},
    flowerRightPos: {x: 4.75, y: -3.1, z: -5},
    flowerLeftScl: 0.006,
    flowerLeftScl_portrait: 0.0035,
    flowerRightScl: 0.0067,
    headerReveal1: 0,
    headerReveal2: 0,
  },
  Palettes: {
    night: {
      textureURL: './tex/_13_PAPA/',
      textureName: '_13_PAPA_bg.jpg',
      textColour: '#F2ECE7',
      textColourCTA: '#F9F8E7',
      col_cta_normal: '#e3bf5d',
      col_cta_hover: '#cfac4c',
      col_cta_click: '#e3bf5d',
    },

    day: {
      textureURL: './tex/_6_HYPO/',
      textureName: '_6_HYPO_bg.jpg',
      textColour: '#000000',
      backgroundColour: '#3D071F',
      textColourCTA: '#F9F8E7',
      col_cta_normal: '#12533B',
      col_cta_hover: '#104B36',
      col_cta_click: '#118e64',
    },
  },

  init: function(playcanvasApp) {
    this.playcanvasApp = playcanvasApp;
    this.loaded = false;
    this.ctaBtnCount = 0;
  },
  load: function() {
    // grab correct colour palette depending on DAY / NIGHT
    this.pageConfig = IRWN.isNight ? LandingPageScene.Palettes.night : LandingPageScene.Palettes.day;

    // style the page
    if (IRWN.isNight) document.body.classList.add('irwn-nightmode');
    document.getElementById('landing_preheader').style.color = this.pageConfig.textColour;
    document.getElementById('landing_header1').style.color = this.pageConfig.textColour;
    document.getElementById('landing_header2').style.color = this.pageConfig.textColour;
    document.getElementById('landing_body').style.color = this.pageConfig.textColour;
    document.getElementById('btn_container').style.color = this.pageConfig.textColour;

    document.body.style.setProperty('--top_ui_colour',this.pageConfig.textColour);

    // const elements = document.querySelectorAll('#equalizer-item');
    // for (const e of elements) {
    //   e.style.setProperty('--barColour', this.pageConfig.textColour);
    // }

    // CTA Handlers
    document.getElementById('cta_btn_svg').addEventListener('mouseenter', LandingPageScene.onCtaMouseOver);
    document.getElementById('cta_btn_svg').addEventListener('mouseleave', LandingPageScene.onCtaMouseOut);
    document.getElementById('cta_btn_svg').addEventListener('onmousedown', LandingPageScene.onCtaMouseDown);

    LandingPageScene.onCtaMouseOut();

    // load assets
    AssetLoader.flushQueue();
    // textures
    AssetLoader.queueTexture(this.pageConfig.textureURL + this.pageConfig.textureName);
    AssetLoader.queueTexture('./tex/landing_left.basis');
    AssetLoader.queueTexture('./tex/landing_right.basis');
    // audio (intro ambience)
    AssetLoader.queueAudio('./audio/landing_ambience1.mp3');
    AssetLoader.queueAudio('./audio/landing_ambience2.mp3');
    AssetLoader.queueAudio('./audio/landing_ambience3.mp3');

    AssetLoader.queueTexture('./tex/irwn_creatureAtlas.basis');
    AssetLoader.loadQueue(() => LandingPageScene.onLoadComplete());
  },
  unload: function() {
    this.children.forEach((child) => {
      child.destroy();
    });
    this.children = [];
  },

  onLoadComplete: function() {
    const self = LandingPageScene;
    self.loaded = true;
    const params = LandingPageScene.Params;
    // setup creature material - one mat for all future creatures
    CreatureManager.setupMaterial();

    //------------------------------------> Texture Assets
    // create BG
    self.e_bg = UI.addImageElement('e_bg', self.playcanvasApp.root, this.pageConfig.textureName);
    self.e_bg.setLocalPosition(params.bgPos.x, params.bgPos.y, params.bgPos.z);
    params.bgScl = UI.scaleElementToFitCamera(self.e_bg.element, IRWNCamera.cam);
    self.e_bg.setLocalScale(params.bgScl, params.bgScl, params.bgScl);
    self.e_bg.element.opacity = 0;
    self.children.push(self.e_bg);

    // create left / right planes
    self.e_left = UI.addImageElement('e_left', self.playcanvasApp.root, 'landing_left.basis');
    self.e_left.setLocalPosition(params.flowerLeftPos.x, params.flowerLeftPos.y, params.flowerLeftPos.z);
    self.e_left.setLocalScale(params.flowerLeftScl, params.flowerLeftScl, params.flowerLeftScl);
    self.e_left.element.opacity = 0;
    self.e_left.element.material.shader = MaterialManager.shaders['tubulentDisplace'];
    self.children.push(self.e_left);

    self.e_right = UI.addImageElement('e_right', self.playcanvasApp.root, 'landing_right.basis');
    self.e_right.setLocalPosition(params.flowerRightPos.x, params.flowerRightPos.y, params.flowerRightPos.z);
    self.e_right.setLocalScale(params.flowerRightScl, params.flowerRightScl, params.flowerRightScl);
    self.e_right.element.opacity = 0;
    self.children.push(self.e_right);

    // setup CTA click handler
    document.getElementById('ctaBlob').addEventListener('click', function() {
      // set state to clock
      FSM.setState(FSM_CLOCK);
      ClockScene.loadScene();
    });
    document.getElementById('ctaBlob').style.pointerEvents = 'all';

    // fluid layout reset
    IRWN.resizeHandler();
    this.reveal();
  },
  updateHeaderReveal: function() {
    document.getElementById('landing_preheader').style.setProperty('--reveal', LandingPageScene.Params.landingpreheader + '%');
    document.getElementById('landing_preheader').style.setProperty('--offset', -LandingPageScene.Params.landingpreheader + '%');

    document.getElementById('landing_header1').style.setProperty('--reveal', LandingPageScene.Params.headerReveal1 + '%');
    document.getElementById('landing_header1').style.setProperty('--offset', -LandingPageScene.Params.headerReveal1 + '%');

    document.getElementById('landing_header2').style.setProperty('--reveal', LandingPageScene.Params.headerReveal2 + '%');
    document.getElementById('landing_header2').style.setProperty('--offset', -LandingPageScene.Params.headerReveal2 + '%');
  },
  update: function(dt) {
    this.updateCTABtnPath(dt);
  },
  updateCTABtnPath: function(dt) {
    this.ctaBtnCount += dt * 0.2;
    const pathData = Blob.getPath(110, this.ctaBtnCount);
    document.querySelector('#ctaBlob').setAttribute('d', pathData);
  },
  reveal: function() {
    //------------------------------------> AUDIO
    AudioManager.setupDrone(AudioManager.ambientDrone, ['landing_ambience1.mp3', 'landing_ambience2.mp3', 'landing_ambience3.mp3']);
    AudioManager.playDrone(AudioManager.ambientDrone);

    gsap.killTweensOf('.pre_header');
    gsap.killTweensOf('.landing_header1');
    gsap.killTweensOf('.landing_header2');
    gsap.killTweensOf('.landing_body');
    gsap.killTweensOf('.ctaBlob');
    gsap.killTweensOf('.cta_btn_svg');
    gsap.killTweensOf('.landing_cta');

    gsap.to(this.e_bg.element, {opacity: 1, duration: 1});
    gsap.to(this.e_left.element, {opacity: 1, duration: 2, delay: 0.5});
    gsap.to(this.e_right.element, {opacity: 1, duration: 2, delay: 0.5});

    gsap.to('.pre_header', {bottom: '50px', opacity: 1, delay: 3, duration: 1, ease: 'backOut'});
    gsap.to('.landing_header1', {opacity: 1, delay: 2, duration: 2});
    gsap.to('.landing_header2', {opacity: 1, delay: 2, duration: 2});
    gsap.to(LandingPageScene.Params, {headerReveal1: 100, delay: 2, ease: 'strong.out', duration: 1.5, onUpdate: LandingPageScene.updateHeaderReveal});
    gsap.to(LandingPageScene.Params, {headerReveal2: 100, delay: 2.2, ease: 'strong.Out', duration: 1, onUpdate: LandingPageScene.updateHeaderReveal});
    gsap.to('.landing_body', {opacity: 1, delay: 2.5, duration: 2});
    gsap.to('.cta_btn_svg', {opacity: 1, delay: 3, duration: 2});
    gsap.to('.landing_cta', {opacity: 1, delay: 3, duration: 2});

    IRWNCamera.setDistance(10);
    IRWNCamera.goto(0, 0, 0, 7, 35, 5, 'expo.inOut');
  },
  hide: function() {
    AudioManager.cancelDrones();
    document.getElementById('ctaBlob').style.pointerEvents = 'none';

    gsap.killTweensOf('.pre_header');
    gsap.killTweensOf('.landing_header1');
    gsap.killTweensOf('.landing_header2');
    gsap.killTweensOf('.landing_body');
    gsap.killTweensOf('.ctaBlob');
    gsap.killTweensOf('.cta_btn_svg');
    gsap.killTweensOf('.landing_cta');

    gsap.to('.pre_header', {bottom: '-50px', opacity: 0, delay: 0.4, duration: 0.5, ease: 'expoIn'});
    gsap.to('.landing_header1', {opacity: 0, delay: 0.4, duration: 0.5});
    gsap.to('.landing_header2', {opacity: 0, delay: 0.4, duration: 0.5});
    gsap.to('.landing_body', {opacity: 0, delay: 0.2, duration: 0.5});
    gsap.to('.cta_btn_svg', {opacity: 0, delay: 0, duration: 0.5});
    gsap.to('.landing_cta', {opacity: 0, delay: 0, duration: 0.5, onComplete: LandingPageScene.onHideComplete});
  },
  resizeHandler: function(w, h, pxRatio) {
    const portraitness = h/w;

    if (portraitness < 0.8) {
      if (this.e_left != null) {
        const leftPos = this.Params.flowerLeftPos;
        this.e_left.setLocalPosition(IRWN.getfluidX(leftPos.x, leftPos.z, -1000, -4), leftPos.y, leftPos.z);
        this.e_left.setLocalScale(this.Params.flowerLeftScl, this.Params.flowerLeftScl, 1);
      }
      if (this.e_right != null) {
        const rightPos = this.Params.flowerRightPos;
        this.e_right.setLocalPosition(IRWN.getfluidX(rightPos.x, rightPos.z, 4, 1000), rightPos.y, rightPos.z);
        this.e_right.enabled = true;
      }
    } else {
      // app is in portrait mode, move left flower to middle
      if (this.e_left != null) {
        const leftPos = this.Params.flowerLeftPos_portrait;
        this.e_left.setLocalPosition(leftPos.x, leftPos.y, leftPos.z);
        this.e_left.setLocalScale(this.Params.flowerLeftScl_portrait, this.Params.flowerLeftScl_portrait, 1);
      }

      if (this.e_right != null) {
        const rightPos = this.Params.flowerRightPos;
        this.e_right.setLocalPosition(IRWN.getfluidX(rightPos.x, rightPos.z, 4, 1000), rightPos.y, rightPos.z);
        this.e_right.enabled = false;
      }
    }
  },


  onHideComplete: function() {
    document.getElementById('ctaBlob').removeEventListener('click', LandingPageScene.hide);
  },

  onCtaMouseOut: function() {
    document.querySelector('#ctaBlob').style.fill = LandingPageScene.pageConfig.col_cta_normal;
  },
  onCtaMouseOver: function() {
    document.querySelector('#ctaBlob').style.fill = LandingPageScene.pageConfig.col_cta_hover;
  },
  onCtaMouseDown: function() {
    document.querySelector('#ctaBlob').style.fill = LandingPageScene.pageConfig.col_cta_click;
  },
};
export {LandingPageScene};
